/**
 * Clients Tab Content Component
 *
 * Contains all charts, tables, and visualizations specific to the Clients tab.
 */

import React from 'react';
import { MetricsGrid } from '../MetricsGrid';
import type { MetricData } from '../../types/DashboardTypes';
import styles from './TabContent.module.scss';
import { TopClientsTable } from '../Tables/Clients/TopClientsTable';
import { HorizontalBarChart } from '../Charts/Common/HorizontalBarChart.tsx/HorizontalBarChart';
import { CohortAnalysisTable } from '../Tables/Clients/CohortAnalysisTable';
import { clientsData, dogBreedData, cohortData } from '../Charts/Clients/clientsChartsMockData';

interface ClientsTabContentProps {
    metrics: MetricData[];
}

export const ClientsTabContent: React.FC<ClientsTabContentProps> = ({ metrics }) => {
    return (
        <div className={styles.tabContent}>
            {/* Metrics Grid */}
            <MetricsGrid metrics={metrics} />

            {/* Charts Section - Client-specific visualizations */}
            <div className={styles.chartsSection}>
                {/* Top Clients table */}
                <div className={styles.tableContainer}>
                    <TopClientsTable
                        title="Top clients"
                        data={clientsData}
                    />
                </div>
                <div className={styles.tableContainer}>
                    <HorizontalBarChart
                        data={dogBreedData}
                        title="Top breeds"
                    />
                </div>
            </div>

            {/* Client Analytics */}
            <div className={styles.tableContainer}>
                <CohortAnalysisTable
                    title="Clients cohort analysis"
                    data={cohortData}
                />
            </div>
        </div>
    );
};
